enum ActionType {
    REQUEST_LATEST_UNKNOWN_ASSET_DATA = '[LATEST_UNKNOWN_ASSET] GET LATEST_UNKNOWN_ASSET_DATA',
    RECEIVE_LATEST_UNKNOWN_ASSET_DATA = '[LATEST_UNKNOWN_ASSET] RECEIVE LATEST_UNKNOWN_ASSET_DATA',
}

export default ActionType
